import React from "react";

const Icon = ({ icon, ...props }) => {
  const Icon = icon;
  return <Icon {...props} />;
};

export default Icon;
